import * as Sentry from '@sentry/react';
import type { ReturnTypeFromGetUser } from '@tyro/api';
import { useEffect } from 'react';
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';

export function initSentry(dsn: string) {
  if (process.env.NODE_ENV === 'production') {
    Sentry.init({
      dsn,
      integrations: [
        Sentry.reactRouterV7BrowserTracingIntegration({
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
        Sentry.replayIntegration({
          maskAllText: true,
          blockAllMedia: true,
        }),
      ],
      tracePropagationTargets: [/^https:\/\/api\.tyro\.school\/api/],
      tracesSampleRate: 0.5,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }
}

export const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

export function setSentryUser(
  activeProfile: ReturnTypeFromGetUser['activeProfile'],
) {
  if (activeProfile?.partyId) {
    Sentry.setUser({
      id: String(activeProfile.partyId),
      segment: activeProfile.profileType?.userType ?? 'unknown',
      tenant: activeProfile.tenant?.tenant ?? 'unknown',
    });
  }
}
